
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface AlertMessageProps {
  type: "verification" | "existing";
  email: string;
  countdown: number;
}

export const AlertMessage = ({ type, email, countdown }: AlertMessageProps) => {
  const isVerification = type === "verification";
  const alertClass = isVerification ? "bg-blue-50 border-blue-200" : "bg-red-50 border-red-200";
  const iconClass = isVerification ? "text-blue-600" : "text-red-600";
  const textClass = isVerification ? "text-blue-700" : "text-red-700";

  return (
    <Alert className={alertClass}>
      <AlertCircle className={`h-4 w-4 ${iconClass}`} />
      <AlertDescription className={textClass}>
        <p className="mb-2">
          {isVerification ? (
            <>
              We've sent a verification email to <span className="font-medium">{email}</span>.
              Please check your inbox and click the verification link to activate your account.
            </>
          ) : (
            <>
              An account with the email <span className="font-medium">{email}</span> already exists.
            </>
          )}
        </p>
        <p className="text-sm">
          Redirecting to login page in {countdown} seconds...
        </p>
      </AlertDescription>
    </Alert>
  );
};
